import compileContract from '../../compile/c1-contract.json';
import { phpCopy } from '../../php-compat';
import { catalogId } from './shared';
import type { PortEnv } from '../../port-contract';
/** Literal source catalog constants, not fixture/oracle results. */
const statusIds: Readonly<Record<string,string|null>> = {
  "concentrating": "E7FDB796-26DA-E0F5-8F88-C21FE01D923B",
  "dying": "8AE129AF-52D8-CCE8-706A-85767DB52740",
  "dying_state": "78C6CC42-BCCE-4F22-9FC5-41F8D7E70944",
  "dying_state_1": "EE063289-1AF3-41CF-B73C-64A0556E6D07",
  "dying_state_2": "2EAAA2E8-1B9C-196D-3E58-C29C09FF8492",
  "grappled": "0C2A8037-B0BC-8300-C818-198881B00E7D",
  "grappling": "E4A34093-AAAB-6453-BCE0-FBA65EE263AD",
  "hasted": "091B2BEE-7F61-D7DB-0CF1-6D255F4B7663",
  "maimed": "A5CDC77C-D224-DD5F-291B-EF8DF2EA443D",
  "piloted": "DDC66C31-4093-84AF-18BB-093D924B8738",
  "piloting": "A1F1FAF2-DA1E-D537-36C2-2B74DC82CB12",
  "recovery_state": "611DFED0-9AD1-5500-AF5B-DE7CBD9DDF64",
  "recovery_state_1": "553734EC-33D3-4527-AB2E-EF48ACED8DF0",
  "recovery_state_2": "9AA7588A-4575-9550-343D-6ADB0C74C17F",
  "restrained": "E34AF232-5438-88FC-9A9F-73850CCCFD51",
  "ridden": "F13F6A58-FE91-F24D-12BE-BE7CCAD81A40",
  "riding": "FF8D219A-2A83-0EE5-A222-E748753E8D0B",
  "unconscious": "F73BA661-ADD2-26E0-E265-FBEB7E5E6AF1"
};
const houseIds: Readonly<Record<string,string|null>> = {
  "maimed_on_dying_stratum_fail_by_5": "0A0B2172-AF81-5D5B-188C-294D5DDB7B74"
};
export const abilityTypes = (): string[] => phpCopy(compileContract.abilityTypes);
export const vitalityIds = (): string[] => phpCopy(compileContract.vitalityStatusIds);
export function statusId(env: PortEnv<object>, variable: string): string|null {
    return catalogId(env, 'StatusEffect', variable, statusIds[variable] ?? null);
}
export function houseRuleId(env: PortEnv<object>, variable: string): string|null {
    return catalogId(env, 'CampaignHouseRuleType', variable, houseIds[variable] ?? null);
}
